// src/config/supabase.ts
/**
 * 🔥 Supabase Client Configuration
 * Backend cloud per authentication e database
 */

import { createClient } from '@supabase/supabase-js';

// Environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Validate configuration
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase configuration missing!');
  console.error('   Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to .env.local');
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Helper: Check if Supabase is configured
export const isSupabaseConfigured = () => {
  return !!(supabaseUrl && supabaseAnonKey && supabaseUrl !== 'https://your-project.supabase.co');
};

// Log configuration status (URL only in development to avoid info leakage)
if (isSupabaseConfigured()) {
  if (process.env.NODE_ENV !== 'production') {
    console.log('✅ Supabase configured:', supabaseUrl);
  }
} else {
  console.warn('⚠️ Supabase NOT configured. Using localStorage fallback.');
}
